import type { LBNodeData } from '@/proto/logiblocks/logiblocks';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { LogoutIcon } from '@/assets/icons/icons';
import { InboundTriggerCustomization } from './InboundTriggerCustomization';
import { inboundEventTypeList } from '@/common/static_data';
import { defaultNodeData } from '../../graphUtils';

export const InboundTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'inbound_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Inbound event',

  hasInput: false,

  getIcon: (size: number) => <LogoutIcon width={size} height={size} />,

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const d = data.inbound_trigger;
    if (!d?.inbound_event_type) return '';
    return (
      inboundEventTypeList.find((x) => x.value === d.inbound_event_type)
        ?.label ?? ''
    );
  },

  CustomizationComponent: InboundTriggerCustomization,

  createDefaultNodeData: () =>
    defaultNodeData('inbound_trigger', {
      inbound_event_type: '',
      phone_number: '',
      tracking_link_types: [],
    }),
};
